/**
 * Equality check based on object length and values
 * @param obj1
 * @param obj2
 * @returns {boolean}
 */
export function objectEquals(obj1: any, obj2: any) {
    if (typeof obj1 !== "object" || typeof obj2 !== "object") {
        return false;
    }

    if (Object.keys(obj1).length !== Object.keys(obj2).length) {
        return false;
    }

    for (const key in obj1) {
        if (!keyAndValueAreIdentical(key, obj1, obj2)) {
            return false;
        }
    }
    return true;
}

function keyAndValueAreIdentical(key: any, obj1: any, obj2: any) {
    if (Object.prototype.hasOwnProperty.call(obj1, key) && Object.prototype.hasOwnProperty.call(obj2, key)) {
        if (obj1[key] !== obj2[key]) {
            return false;
        }
    } else {
        return false;
    }
}

/**
 * flip keys and values
 * https://stackoverflow.com/questions/23013573/swap-key-with-value-in-object
 * @param obj object
 */
export function flipKeysAndValues(obj: { [key: string]: string | number }) {
    return Object.keys(obj).reduce((result: { [key: string]: string | number }, key) => {
        result[obj[key]] = key;
        return result;
    }, {});
}

/**
 * https://stackoverflow.com/questions/679915/how-do-i-test-for-an-empty-javascript-object
 * @param obj
 */
export function objectIsEmpty(obj: any) {
    return obj
        && Object.keys(obj).length === 0
        && Object.getPrototypeOf(obj) === Object.prototype;
}
